import { Action } from '@ngrx/store';

import { User } from '@stylehaven/components';

export enum UserActionTypes {
    Set = '[User] Set',
    Unset = '[User] Unset'
}

export class SetUser implements Action {
    type: UserActionTypes.Set = UserActionTypes.Set;
    constructor(public payload: User) {}
}

export class UnsetUser implements Action {
    type: UserActionTypes.Unset = UserActionTypes.Unset;
}

export type UserActions = SetUser | UnsetUser;
